import { IGetMonitoramentoChecklistEmpresaDropDownUseCase } from "../../../presentation/useCases/read/get_monitoramento_checklist_empresa_drop_down_use_case";
import { MonitoramentoChecklistEmpresa } from "../../models/monitoramento_checklist_empresa";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetMonitoramentoChecklistEmpresaDropDownUseCase
 */

export class GetMonitoramentoChecklistEmpresaDropDownUseCase
  implements IGetMonitoramentoChecklistEmpresaDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getMonitoramentoChecklistEmpresaDropDown(
    idObra: number,
  ): Promise<MonitoramentoChecklistEmpresa[]> {
    return await this.repository.getMonitoramentoChecklistEmpresaDropDown(idObra);
  }
}
